module.exports = __webpack_public_path__ + "img/ricelog_pinicon_091.24ed1a17.png";